import React from "react";

const TaxReportingStatusIndicator = ({ status }) => {
    let color = '';
    switch (status) {
      case 'complete':
        color = '#0B6A6B';
        break;
      case 'pending':
        color = '#efb641';
        break;
      case 'incomplete':
        color = '#DC143C';
        break;
      default:
        color = '#e4e7f0'; // Default to gray if status is unknown
    }
  
    const circleStyle = {
      width: '10px',
      height: '10px',
      borderRadius: '50%',
      backgroundColor: color,
      display: 'inline-block',
      marginRight: '10px',
      boxShadow: `0 0 5px ${color}`, /* Glow effect */
    animation: 'glow 1.5s infinite alternate' /* Animation effect */
    };
  
    return (
      <div style={circleStyle}></div>
    );
  };

  export default TaxReportingStatusIndicator;
